import React, { memo } from 'react';
import { Controller } from 'react-hook-form';
import { Box, IconButton, makeStyles } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import { COLOR_BLUE, COLOR_BORDER, COLOR_ORANGE } from '../../styles/colors';
import { EvaluationFieldProps } from '../../types/Evaluation';
import Input from '../Input';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    minWidth: 220,
    width: '100%',
  },
  inputWrapper: {
    position: 'relative',
    width: '100%',
  },
  textField: {
    width: '100%',
    '& .MuiFilledInput-root': {
      paddingRight: 36,
    },
  },
  removeButton: {
    position: 'absolute',
    top: '50%',
    right: 4,
    transform: 'translateY(-50%)',
    padding: 4,
    color: COLOR_BORDER,
    '&:hover': {
      color: COLOR_ORANGE,
    },
  },
  addButton: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: COLOR_BLUE,
    fontSize: theme.typography.pxToRem(12),
    marginTop: theme.spacing(0.5),
  },
}), { name: 'MultiTextInput' });

function MultiTextInput({ name, control, label }: EvaluationFieldProps) {
  const classes = useStyles();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => {
        const items: string[] = Array.isArray(value) ? value : [];

        const handleAdd = () => {
          onChange([...items, '']);
        };

        const handleRemove = (index: number) => {
          onChange(items.filter((_, i) => i !== index));
        };

        const handleChange = (index: number, newValue: string) => {
          onChange(items.map((item, i) => (i === index ? newValue : item)));
        };

        return (
          <Box className={classes.container}>
            {items.map((item, index) => (
              <Box key={index} className={classes.inputWrapper}>
                <Input 
                    className={classes.textField}
                    label={`${label} ${index + 1}`}
                    value={item}
                    onChange={(v, e) => handleChange(index, e.target.value)}
                />
                <IconButton className={classes.removeButton} onClick={() => handleRemove(index)}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            ))}
            <Box className={classes.addButton} onClick={handleAdd}>
                <AddIcon fontSize="small" />
                <span style={{ marginLeft: 4 }}>Add {label}</span>
            </Box>
          </Box>
        );
      }}
    />
  );
}

export default memo(MultiTextInput);
